if (!customElements.get("th-collection-card")) {
  class ThCollectionCard extends HTMLElement {
    constructor() {
      super();

      this.swatchesSelector = "[data-collection-swatch]";
      this.swatchImgSelector = "[data-swatch-img]";
    }

    connectedCallback() {
      setTimeout(() => {
        this.attachListeners();
      });
    }

    attachListeners() {
      this.querySelectorAll(this.swatchesSelector).forEach(
        (swatch) => {
          swatch.addEventListener(
            "click",
            this.handleSwatchChange.bind(this, swatch)
          );
        }
      );
    }

    handleSwatchChange(swatch, event) {
      event.preventDefault();
      const swatchId = swatch.dataset.collectionSwatchId;
      const activeImg = this.querySelector(`#${swatchId}`);
      if (!activeImg) {return}
      const swatches = this.querySelectorAll(this.swatchesSelector);
      const swatchImgs = this.querySelectorAll(this.swatchImgSelector);
      //remove active classes
      swatches.forEach(el => {
        el.classList.remove('active');
      });
      swatchImgs.forEach(el => {
        el.classList.remove('active');
      });
      //add active classes/styles
      swatch.classList.add('active');
      activeImg.classList.add('active');
      activeImg.style.opacity = 0;
      for (let i = 0; i < 1.1; i = i + 0.1) {           
        setTimeout(function(){activeImg.style.opacity = i;},50)                       
      }
    }
  }

  customElements.define("th-collection-card", ThCollectionCard);
}